import { Permissions } from '../../models/enums/permissions';
import * as React from 'react';
import { HasPermission } from '../../containers/authorization-helpers/HasPermission';
import { ClearButton } from '../button/ClearButton';
import './DataSplitView.scss';

// #region Component Props 

interface IProps {
    icon                    : any;
    children                : any;
    title                   : string;
    subtitle                : string; 
    actionClick?            : any;
    actionText?             : string;
    actionDisabled?         : boolean;
    kitchenSink?            : any;
    classes?                : string;
    isErrorData?            : boolean;
    requiredPermissions?    : Permissions[];
}

// #endregion

const DataSplitView : React.SFC<IProps> = (props) => {

    const { 
        actionClick, 
        actionText, 
        icon, 
        children, 
        title, 
        subtitle, 
        kitchenSink, 
        actionDisabled, 
        classes, 
        isErrorData,
        requiredPermissions
    } = props;

    return <div className="row">
        <div className="col">
            <div className={"data-splitview" + (isErrorData ? ' has-error' : '')}>
                <div className="icon-container">
                    <i className={ `la la-${ icon }` } />
                </div>

                <div className="body-container">
                    <div className="title-row">
                        <span className="title">
                            <h2>{ title }</h2>
                            <span className="subtitle">{ subtitle }</span>
                        </span>
                        {
                            actionClick ?
                            <HasPermission requiredPermissions={ requiredPermissions ? requiredPermissions : []}>
                                <div>
                                    <ClearButton
                                        id="splitviewaction"
                                        disabled={ actionDisabled }
                                        text={ actionText ? actionText : '' }
                                        icon=""
                                        onBtnClick={ actionClick} />
                                </div>
                            </HasPermission> : null
                        }                        
                    </div>
                    <div className={"detail-row " + classes }>
                        <ul>
                            {
                                children.length > 1 
                                ? children.map((c: any, idx: number) => (
                                    <li key={idx}>{c}</li>
                                )) 
                                : <li key="dsv-1">{children}</li>
                            }
                            
                        </ul>
                        {
                            kitchenSink ? kitchenSink : null
                        }
                    </div>
                </div>
            </div>
        </div>
    </div>;

};

DataSplitView.defaultProps = {
    actionClick: undefined,
    actionText: '',
    actionDisabled: false,
    kitchenSink: [],
    classes: '',
    isErrorData: false,
    requiredPermissions: []
};

export { DataSplitView };
